import { render } from "./chooseLayerToCopyModal.vue?vue&type=template&id=9a04adec&scoped=true&ts=true"
import script from "./chooseLayerToCopyModal.vue?vue&type=script&lang=ts"
export * from "./chooseLayerToCopyModal.vue?vue&type=script&lang=ts"

import "./chooseLayerToCopyModal.vue?vue&type=style&index=0&id=9a04adec&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a04adec"]])

export default __exports__